<template>
    <span>
        <template v-if="store.isLoading">
            <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            {{$t(buttonText)}} <i class="fa fa-xs fa-angle-right"></i>
        </template>
    </span>
</template>

<script setup>
import { useMainStore } from '../includes/store';
const store = useMainStore();

const props = defineProps({
    buttonText: {
        type: String,
        default: 'Liigu edasi'
    }
});
</script>
